import { crmTypes } from 'utils/helpers/crm';
import { accessLevels } from '../helpers';

const canPush = (list, user) =>
  accessLevels.push.includes(list.userAccessLevel) || user.isAccountManager;
export const hasPermissionToPushExport = user =>
  !user.isRateLimited && !user.disableExport;

export const canPushToCrm = (list, user, crmType) => {
  const crmAvailable =
    crmType === crmTypes.SALESFORCE
      ? user.canPushToSalesforce && user.isSalesforceAuthenticated
      : user.canPushToHubspot && user.isHubspotAuthenticated;
  return canPush(list, user) && hasPermissionToPushExport(user) && crmAvailable;
};

export const canModify = (list, user) =>
  accessLevels.modifyList.includes(list.userAccessLevel) ||
  user.isAccountManager;
export const canModifyMembers = (list, user) =>
  (accessLevels.modifyMembers.includes(list.userAccessLevel) ||
    user.isAccountManager) &&
  list.enabled;
